import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const IosPrivacyPolicy = () => {
  return (
    <section className="py-5 bg-light">
      <Container>
        <Row>
          <Col md={8} lg={6} className="mx-auto">
            <h1 className="text-center mb-4">Privacy Policy</h1>
            
            <p className="mb-4">
              Westron built this app as a Free app. This SERVICE is provided by Westron at no cost and is intended for use as is.
            </p>

            <p className="mb-4">
              This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decides to use our Service.
            </p>

            <p className="mb-4">
              If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
            </p>

            <h2 className="mt-4 mb-3">Information Collection and Use</h2>

            <p className="mb-4">
              For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to access to media, files, photos, contact info, and device info. The information that we request will be retained on your device and is not collected by us in any way.
            </p>

            <p className="mb-4">
              The app does use third-party services that may collect information used to identify you.
            </p>

            <p className="mb-4">
              <strong>Tracking</strong>: Our app may request permission to track your activity across apps and websites owned by other companies for personalized advertising and analytics purposes. This tracking is conducted by third-party services and is governed by their privacy policies. You can control tracking preferences through your device settings.
            </p>

            <p className="mb-4">Link to the privacy policy of third-party service providers used by the app:</p>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://www.google.com/policies/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  Google Play Services
                </a>
              </li>
              {/* Add more third-party services as needed */}
            </ul>

            <h2 className="mt-4 mb-3">Log Data</h2>

            <p className="mb-4">
              We want to inform you that whenever you use our Service, in case of an error in the app we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
            </p>

            <h2 className="mt-4 mb-3">Cookies</h2>

            <p className="mb-4">
              Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
            </p>

            <p className="mb-4">
              This Service does not use these “cookies” explicitly. However, the app may use third-party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
            </p>

            <h2 className="mt-4 mb-3">Service Providers</h2>

            <p className="mb-4">We may employ third-party companies and individuals due to the following reasons:</p>

            <ul className="list-unstyled mb-4">
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul>

            <p className="mb-4">
              We want to inform users of this Service that these third parties have access to their Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
            </p>

            <h2 className="mt-4 mb-3">Security</h2>

            <p className="mb-4">
              We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
            </p>

            <h2 className="mt-4 mb-3">Links to Other Sites</h2>

            <p className="mb-4">
              This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
            </p>

            <h2 className="mt-4 mb-3">Children’s Privacy</h2>

            <p className="mb-4">
              These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13 years of age. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do the necessary actions.
            </p>

            <h2 className="mt-4 mb-3">Changes to This Privacy Policy</h2>

            <p className="mb-4">
              We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
            </p>

            <p className="mb-4">This policy is effective as of 2024-07-17</p>

            <h2 className="mt-4 mb-3">Contact Us</h2>

            <p className="mb-4">
              If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:cse.rajeevyadav@gmail.com" className="text-primary">cse.rajeevyadav@gmail.com</a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default IosPrivacyPolicy;
